import React from 'react';
import withStyles from '../utils/withStyles';
import Typography from '@mui/material/Typography';
import NineBoxCell from './NineBoxCell';
import {withLanguage} from './common/Texts';
import {PRIMARY_BLUE} from '../theme';

const COLUMN_HEADERS = ['needs_development', 'meets_expectations', 'exceeds_expectations'];
const PERFORMANCE_LABELS = ['poor', 'good', 'outstanding'];

function NineBoxGrid({classes, getEmployees, language, config}) {
    const t = withLanguage(language);

    return (
        <div className={classes.outerWrapper}>
            {/* Y-axis label */}
            <div className={classes.yAxisWrapper}>
                <span className={classes.yAxisArrow}>↑</span>
                <Typography className={classes.yAxisText}>{t(config.yAxisKey)}</Typography>
                <span className={classes.yAxisArrow}>↓</span>
            </div>

            <div className={classes.gridOuter}>
                <div className={classes.gridArea}>
                    {/* Column header row */}
                    <div /> {/* empty corner */}
                    {COLUMN_HEADERS.map((key, i) => (
                        <div key={i} className={classes.colHeader}>
                            <Typography variant="subtitle2" className={classes.colHeaderText}>{t(key)}</Typography>
                        </div>
                    ))}

                    {/* Data rows */}
                    {config.rows.map((row, rowIndex) => (
                        <React.Fragment key={rowIndex}>
                            <div className={classes.rowLabel}>
                                <Typography className={classes.rowLabelText}>{t(config.rowLabels[rowIndex])}</Typography>
                            </div>
                            {row.map((cell, colIndex) => (
                                <NineBoxCell
                                    key={colIndex}
                                    label={t(cell.label)}
                                    employees={getEmployees(cell.potential, cell.performance)}
                                    bg={cell.bg}
                                    color={cell.color}
                                />
                            ))}
                        </React.Fragment>
                    ))}

                    {/* Bottom performance labels */}
                    <div /> {/* empty corner */}
                    {PERFORMANCE_LABELS.map((key, i) => (
                        <div key={i} className={classes.perfLabel}>
                            <Typography variant="subtitle2" className={classes.perfLabelText}>{t(key)}</Typography>
                        </div>
                    ))}
                </div>

                {/* X-axis label */}
                <div className={classes.xAxisWrapper}>
                    <span className={classes.xAxisArrow}>←</span>
                    <Typography className={classes.xAxisText}>{t('performance')}</Typography>
                    <span className={classes.xAxisArrow}>→</span>
                </div>
            </div>
        </div>
    );
}

const styles = {
    outerWrapper: {
        display: 'flex',
        alignItems: 'stretch',
    },
    yAxisWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 46,    /* clear column header row */
        paddingBottom: 68, /* clear perf labels + x-axis row */
        marginRight: 6,
    },
    yAxisArrow: {
        fontWeight: 700,
        fontSize: 20,
        lineHeight: 1,
        color: PRIMARY_BLUE,
    },
    yAxisText: {
        writingMode: 'vertical-rl',
        transform: 'rotate(180deg)',
        fontWeight: 700,
        fontSize: '0.95rem',
        letterSpacing: 1,
        flex: 1,
        textAlign: 'center',
        padding: '8px 0',
        color: PRIMARY_BLUE,
    },
    gridOuter: {
        flex: 1,
    },
    gridArea: {
        display: 'grid',
        gridTemplateColumns: '80px 1fr 1fr 1fr',
        gap: 6,
    },
    colHeader: {
        textAlign: 'center',
        padding: '6px 4px 12px',
    },
    colHeaderText: {
        fontWeight: 700,
        color: PRIMARY_BLUE,
    },
    rowLabel: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    rowLabelText: {
        writingMode: 'vertical-rl',
        transform: 'rotate(180deg)',
        fontWeight: 600,
        fontSize: '0.85rem',
        letterSpacing: 1,
        color: PRIMARY_BLUE,
        textAlign: 'center',
    },
    perfLabel: {
        textAlign: 'center',
        padding: '10px 4px 4px',
    },
    perfLabelText: {
        fontWeight: 700,
        color: PRIMARY_BLUE,
    },
    xAxisWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 8,
        marginLeft: 86, /* align with data columns */
        gap: 8,
    },
    xAxisArrow: {
        fontWeight: 700,
        fontSize: '1.1rem',
        color: PRIMARY_BLUE,
    },
    xAxisText: {
        fontWeight: 700,
        fontSize: '0.95rem',
        letterSpacing: 1,
        color: PRIMARY_BLUE,
    },
};

export default withStyles(styles)(NineBoxGrid);
